export default {
  billDetail: {
    collapseTitle: {
      baseTitle: '基本信息',
      billStatusTitle: '票据状态信息',
      collectBillTitle: '应收票据附件',
      billPaymentTitle: '票据解付',
      payBillTitle: '应付票据附件',
      payInfoTitle: '付款信息',
    },
    tabTitle: {
      contractTitle: '认领信息',
      discountTitle: '贴现信息',
      reciteTitle: '背书信息',
      collectionTitle: '托收信息',
      pledgeTitle: '质押信息',
      accountingVoucherTitle: '会计凭证',
      paymentTitle: '解付信息',
    },
    baseForm: {
      collectBillSerialNumber: '应收票据流水号',
      payBillSerialNumber: '应付票据流水号',
      billCompanyCode: '公司',
      copyBillCode: '原应收票据号',
      collectBillCode: '应收票据号',
      payBillCode: '应付票据号',
      billProperty: '票据性质',
      billCategory: '票据类型',
      copyBillTakeDepartmentNo: '原收票部门',
      collectBillTakeDepartmentNo: '收票部门',
      payBillTakeDepartmentNo: '开票部门',
      billAmount: '票面金额',
      currency: '币别',
      expiringDate: '到期日',
      collectBillMakerName: '开票人',
      payBillMakerName: '出票人',
      collectBillMakeDate: '开票日期',
      payBillMakeDate: '出票日期',
      collectBillMakeBankNo: '开票银行',
      payBillMakeBankNo: '出票银行',
      collectBillMakeBankAccount: '开票银行账号',
      payBillMakeBankAccount: '出票银行账号',
      billStatus: '票据状态',
      claimStatus: '认领状态',
      accountingStatus: '入账状态',
      collectBillTakerName: '收票人',
      payBillTakerName: '收款人',
      billTakeDate: '收票日期',
      collectBillTakeBankNo: '收票银行',
      payBillTakeBankNo: '收款银行',
      collectBillTakeBankAccount: '收票银行账号',
      payBillTakeBankAccount: '收款银行账号',
      arrivalBranchNo: '入账银行',
      arrivalBankAccount: '入账银行账号',
      billSize: '大小票',
      paymentNature: '款项性质',
      billRecorderName: '录入人',
      billRecordDate: '录入日期',
      billMark: '备注',
      isCopy: '是否复制',
      isClaim: '是否认领',
      isInterest: '是否计息',
      isRecourse: '是否带追索权',
      discountType: '贴现类型',
      ysbsrHN: '应收背书人',

      billMakePledgeInfo: '出票保证信息',
      acceptorName: '承兑人',
      acceptBankNo: '承兑银行',
      acceptBankBranchNo: '承兑银行行号',
      acceptBankAccount: '承兑人银行账号',
      acceptDate: '承兑日期',
      projectInitiationNo: '项目编码',
      payableSettlementNo: '结算单',
      contractNo: '交易合同号',
      billMakerPromiseInfo: '出票人承诺信息',
      acceptorAcceptInfo: '承兑人承兑信息',
      billAcceptPledgeInfo: '承兑保证信息',
      isAssignment: '能否转让',
      isRefundDeposit: '已退回保证金',
      marginRate: '保证金比例',
      marginAmount: '保证金金额',
      cashflowCode: '现金流量代码',
      marginBankAccount: '保证金银行',
      customerNo: '客户',
    },
    placeholder: {
      auto: '自动生成',
    },
    contranctColumn: {
      contractNo: '销售合同号',
      externalContractNo: '外部合同号',
      apportionAmount: '金额',
      customerNo: '客户',
      contractSalesmanName: '业务员',
      contractBusinessDepartmentNo: '部门',
      projectInitiationNo: '项目编码',
      payableSettlementNo: '结算单',
      claimDate: '认领日期',
    },
    payInfoContranctColumn: {
      payableSettlementNo: '付款单号',
      payDate: '付款日期',
      payAmount: '付款金额',
      payBankName: '付款银行账户名称',
      payBankAccount: '付款银行账号',
    },
    contranctColumnPlaceholder: {
      apportionAmountPlaceholder: '请输入金额',
      customerNoPlaceholder: '请选择客户',
      contractBusinessDepartmentNoPlaceholder: '请选择部门',
    },
    pledgeColumnPlaceholder: {
      pledgeDatePlaceholder: '请选择质押日期',
    },
    discountForm: {
      discountDate: '贴现日期',
      discountRate: '贴现利率',
      discountDays: '贴现天数',
      billBookValue: '票据账面价值',
      billMaturityValue: '票据到期价值',
      preDiscountCharge: '预计贴现息',
      discountCharge: '实际贴现息',
      discountIncomeAmount: '实际贴现所得金额',
      discountReceiptDate: '贴现收款日期',
      serviceCharge: '手续费',
      serviceChargeType: '贴现息科目',
      serviceChargeSerialNumber: '贴现息现金流量代码',
      discountDepartmentCode: '贴现部门',
      discountBankNo: '贴现银行',
      discountBankAccount: '贴现银行账号',
      bearerType: '贴现承担方',
    },
    reciteForm: {
      endorseDate: '背书日期',
      endorsePurpose: '背书目的',
      endorseDepartmentNo: '背书部门',
      endorseeName: '被背书人',
      paymentOrderNo: '付款单号',
      marginRatio: '背书内部保证金比率',
      paymentNum: '付款单号',
    },
    collectionForm: {
      collectionBankNo: '托收银行',
      collectionBankAccount: '托收银行账号',
      collectionCashFlowCode: '托收现金流量代码',
      collectionDate: '托收日期',
      actualReceiptDate: '实际收款日期',
      collectionReturnDate: '托收退回日期',
      serviceCharge: '手续费',
      serviceChargeType: '手续费科目',
      serviceChargeSerialNumber: '手续费现金流量代码',
    },
    pledgeForm: {
      pledgeCompanyCode: '公司代码',
      billCode: '票据号',
      pledgeLineNo: '行项目',
      pledgeBankNo: '质押银行',
      pledgeBankAccount: '质押银行账号',
      pledgeDate: '质押日期',
      redemptionDate: '赎回日期',
      pledgeOperatorName: '操作人',
      pledgeOperateDate: '操作日期',
    },
    paymentForm: {
      marginPayAmount: '保证金解付金额',
      payAmount: '解付金额',
      payDate: '解付日期',
      bankUnionNumber: '解付银行行号',
      bankAccount: '解付银行账号',
      cashflowCode: '现金流量代码',
      marginBankAccount: '保证金支付银行',
      accountingStatus: '解付入账状态',
    },
    button: {
      save: '保 存',
      close: '关 闭',
      payment: '已解付',
      makeAccountingVoucher: '生成会计凭证',
    },
    message: {
      noDiscountType: '请选择贴现类型！',
      verifyCustomer: '认领信息客户必需与基本信息客户保持一致！',
      verifyDepartment: '认领信息部门必需与基本信息收票部门保持一致！',
      verifyAmountIsEqual: '合同金额累计必需等于票面金额！',
      verifyAmount: '合同金额累计必需小于票面金额！',
      discountVerifyAmount: '贴现息+贴现所得金额必需等于票据账面价值！',
      saveSussess: '保存成功！',
      deleteSuccess: '删除成功！',
      cancelled: '已取消！',
      noData: '您还未选择任何数据！',
      billCodeUsed: '该应收票据号在系统中已存在，请重新维护',
      noExpiringDateTip: '到期日不能为空',
      noDiscountDateTip: '贴现日期不能为空',
      discountIncomeAmountTip: '贴现息+实际贴现所得额不等于票面金额！',
    },
  },
};
